import React, { useEffect, useState, useContext } from 'react';
import { ArrowRightIcon, BellIcon, PencilRulerIcon, DollarSignIcon, ClockIcon, CheckCircleIcon, AlertCircleIcon, TrendingUpIcon, FileTextIcon, CalendarIcon, LayoutDashboardIcon, BarChart3Icon, UsersIcon, ZapIcon, SearchIcon, ShieldIcon, ChevronRightIcon, ChevronDownIcon, MapPinIcon, CloudIcon, RefreshCwIcon, HeadphonesIcon, MailIcon, MessageSquareIcon, StarIcon } from 'lucide-react';
import { FairContext } from '../contexts/FairContext';
import { FairPromotion } from '../components/FairPromotion';
import { EclipseModal } from '../components/EclipseModal';
export function HomePageAlternative({
  onNavigate
}: {
  onNavigate?: any;
}) {
  const {
    activeFair,
    setActiveFair
  } = useContext(FairContext);
  const [showPromotion, setShowPromotion] = useState(true);
  const [showEclipse, setShowEclipse] = useState(true);
  // Add an effect to log when the active fair changes
  useEffect(() => {
    if (activeFair && activeFair.hasQRCode) {
      console.log('Home page detected active fair with QR:', activeFair);
      setShowPromotion(true);
    }
  }, [activeFair]);
  const handleClosePromotion = () => {
    setShowPromotion(false);
  };
  // Mock data for alerts and pending orders
  const alerts = [{
    id: 1,
    type: 'order',
    title: 'New order received',
    description: 'Order #HX6AA6-3 received from AiscoEurope SAU',
    time: '10 minutes',
    priority: 'high'
  }, {
    id: 2,
    type: 'quote',
    title: 'Quote pending approval',
    description: 'Quote #DKEYFH-1 awaiting approval',
    time: '2 hours',
    priority: 'medium'
  }, {
    id: 3,
    type: 'design',
    title: 'Design shared',
    description: 'Daniel Fernández shared a design with you',
    time: '1 day',
    priority: 'low'
  }, {
    id: 4,
    type: 'quote',
    title: '3 new quotes created',
    description: 'New quotes have been created in the last 24 hours',
    time: '5 hours',
    priority: 'medium'
  }, {
    id: 5,
    type: 'quote',
    title: '4 quotes expiring soon',
    description: 'Quotes that will expire in the next 7 days',
    time: '1 day',
    priority: 'high'
  }];
  const pendingOrders = [{
    id: 'HX6AA6-3',
    customer: 'AiscoEurope SAU',
    product: 'Pivot Machine 8" 5/8 GALV',
    amount: '€80,108.29',
    status: 'pending',
    date: 'Jun 13, 2025'
  }, {
    id: 'DKEYFH-1',
    customer: 'HMB Irrigation',
    product: 'Reeltown 1058 ft wiper',
    amount: '$64,699.26',
    status: 'review',
    date: 'Jul 21, 2025'
  }, {
    id: 'T55NVQ',
    customer: 'HMB Irrigation',
    product: 'Pivot CP600',
    amount: '€72,350.00',
    status: 'approved',
    date: 'Jul 12, 2025'
  }];
  const stats = [{
    title: 'Quotes',
    value: '12',
    change: '+3',
    icon: <FileTextIcon size={20} className="text-white" data-id="element-9135" data-mp="1cgp95n2o53oe" />,
    color: 'from-blue-600 to-blue-800'
  }, {
    title: 'Designs',
    value: '8',
    change: '+2',
    icon: <PencilRulerIcon size={20} className="text-white" data-id="element-9136" data-mp="108q7jrwo4ws" />,
    color: 'from-blue-500 to-indigo-700'
  }, {
    title: 'Orders',
    value: '5',
    change: '+1',
    icon: <CheckCircleIcon size={20} className="text-white" data-id="element-9137" data-mp="3kmhmfhuwi3w8" />,
    color: 'from-indigo-600 to-blue-900'
  }, {
    title: 'Clients',
    value: '24',
    change: '+4',
    icon: <UsersIcon size={20} className="text-white" data-id="element-9138" data-mp="2eifhxpyuj23" />,
    color: 'from-blue-700 to-indigo-800'
  }];
  return <div className="flex flex-col min-h-screen bg-gradient-to-br from-slate-900 via-blue-950 to-indigo-950" data-id="element-9139" data-mp="3tl33t9omzcvf">
      {/* Eclipse simulator shown on app start */}
      <EclipseModal open={showEclipse} onClose={() => setShowEclipse(false)} data-id="element-9140" data-mp="31x1a7x9usmzz" />

      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-9141" data-mp="3fopkrw4gf3eu">
        <div className="absolute top-[10%] left-[5%] w-64 h-64 bg-blue-600 rounded-full mix-blend-multiply filter blur-[80px] opacity-20" data-id="element-9142" data-mp="3auv7baffzko7"></div>
        <div className="absolute top-[40%] right-[10%] w-72 h-72 bg-purple-600 rounded-full mix-blend-multiply filter blur-[80px] opacity-20" data-id="element-9143" data-mp="2i80n8emjenb9"></div>
        <div className="absolute bottom-[10%] left-[25%] w-80 h-80 bg-teal-600 rounded-full mix-blend-multiply filter blur-[100px] opacity-20" data-id="element-9144" data-mp="2vvspqdied5ju"></div>
      </div>

      {/* Main content */}
      <div className="relative z-10 flex-1" data-id="element-9145" data-mp="35rm5e5rexf5u">
        {/* Fair Promotion Banner (if there's an active fair with QR) */}
        {activeFair && activeFair.hasQRCode && showPromotion && <div className="px-6 md:px-12 pt-6" data-id="element-9146" data-mp="3elh4aw1xy9d1">
            <FairPromotion fair={activeFair} onClose={handleClosePromotion} data-id="element-9147" data-mp="3ekpjmg9vtw1j" />
          </div>}
        {/* Hero section */}
        <div className="px-6 md:px-12 pt-16 pb-12 max-w-7xl mx-auto" data-id="element-9148" data-mp="3jlvd4gbd9nc4">
          <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-9149" data-mp="3ojok3bkhuldg">
            {/* Left column - Text and buttons */}
            <div className="flex-1 text-left" data-id="element-9150" data-mp="3tfvo2ytbxmsr">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-white via-blue-100 to-indigo-200 leading-tight mb-6" data-id="element-9151" data-mp="1u65my2udl4so">
                Design and Quote
                <br data-id="element-9152" data-mp="g9vyk4v7kdz5" />
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-teal-400" data-id="element-9153" data-mp="gb72c4onllq9">
                  PIVOT System
                </span>
              </h1>
              <p className="text-blue-100 text-lg mb-8 max-w-2xl" data-id="element-9154" data-mp="7hahqub50hcy">
                Create precise and efficient irrigation solutions for any
                terrain with our advanced comprehensive management platform
              </p>
              <div className="flex flex-wrap gap-4 mb-8" data-id="element-9155" data-mp="z5m23wishif5">
                <button onClick={() => onNavigate('design')} className="flex items-center justify-center bg-gradient-to-r from-blue-800/80 to-indigo-900/80 hover:from-blue-800 hover:to-indigo-900 text-white px-6 py-3.5 rounded-xl text-lg font-medium transition-all shadow-lg hover:shadow-xl hover:translate-y-[-2px] border border-blue-700/30" data-id="element-9156" data-mp="v7obqqda8qa6">
                  <PencilRulerIcon size={20} className="mr-2" data-id="element-9157" data-mp="35yeetbxxc0bn" />
                  Design System
                  <ArrowRightIcon size={18} className="ml-2" data-id="element-9158" data-mp="37fk55n34pj9m" />
                </button>
                <button onClick={() => onNavigate('quotes')} className="flex items-center justify-center bg-gradient-to-r from-blue-900/80 to-indigo-800/80 hover:from-blue-900 hover:to-indigo-800 text-white px-6 py-3.5 rounded-xl text-lg font-medium transition-all shadow-lg hover:shadow-xl hover:translate-y-[-2px] border border-indigo-700/30" data-id="element-9159" data-mp="37dh84j3k6pve">
                  <DollarSignIcon size={20} className="mr-2" data-id="element-9160" data-mp="2ootz5pi9hgcj" />
                  Create Quote
                  <ArrowRightIcon size={18} className="ml-2" data-id="element-9161" data-mp="2tg2bouew1htx" />
                </button>
              </div>
              <div className="flex items-center gap-3 text-blue-200 text-sm" data-id="element-9162" data-mp="2fp71nesnkuor">
                <div className="flex -space-x-2" data-id="element-9163" data-mp="2jppqczz91kmq">
                  <div className="w-8 h-8 rounded-full bg-gradient-to-r from-blue-400 to-indigo-500 flex items-center justify-center text-white text-xs font-bold" data-id="element-9164" data-mp="2jq903teqx2po">
                    JD
                  </div>
                  <div className="w-8 h-8 rounded-full bg-gradient-to-r from-purple-400 to-pink-500 flex items-center justify-center text-white text-xs font-bold" data-id="element-9165" data-mp="2ardt4f3vnolb">
                    MR
                  </div>
                  <div className="w-8 h-8 rounded-full bg-gradient-to-r from-amber-400 to-orange-500 flex items-center justify-center text-white text-xs font-bold" data-id="element-9166" data-mp="1m6soq37a7cp9">
                    TS
                  </div>
                </div>
                <span data-id="element-9167" data-mp="2a1vfigpnbq8d">+24 active users right now</span>
              </div>
            </div>
            {/* Right column - Large pivot image */}
            <div className="flex-1 flex justify-center" data-id="element-9168" data-mp="2530jue6ky76u">
              <div className="relative" data-id="element-9169" data-mp="2jsg73k6wjuhs">
                <div className="absolute -top-16 -left-16 -right-16 -bottom-16 bg-gradient-to-br from-blue-500/10 to-teal-500/10 rounded-full blur-3xl" data-id="element-9170" data-mp="2jreuvce5h1yh"></div>
                <div className="relative" data-id="element-9171" data-mp="2ss3ceh2r5kg4">
                  <div className="grid grid-cols-2 gap-1 absolute -inset-4 -z-10" data-id="element-9172" data-mp="2st4q6tb5kl1j">
                    <div className="bg-gradient-to-br from-blue-600/5 to-transparent h-20 w-20 rounded-md" data-id="element-9173" data-mp="2osujfefjdqlm"></div>
                    <div className="bg-gradient-to-br from-indigo-600/5 to-transparent h-20 w-20 rounded-md" data-id="element-9174" data-mp="3v5z7wajvno1v"></div>
                    <div className="bg-gradient-to-br from-teal-600/5 to-transparent h-20 w-20 rounded-md" data-id="element-9175" data-mp="41r5tnxzzqre"></div>
                    <div className="bg-gradient-to-br from-purple-600/5 to-transparent h-20 w-20 rounded-md" data-id="element-9176" data-mp="d0mdl4gox8wt"></div>
                  </div>
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ddVxmMM9BG37mQQDtAXhse/8120_pierce.svg" alt="PIVOT System" className="h-64 md:h-80 w-auto object-contain drop-shadow-[0_0_15px_rgba(59,130,246,0.3)]" data-id="element-9177" data-mp="3cgso0k7ckqeh" />
                </div>
              </div>
            </div>
          </div>

          {/* Stats cards */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-16" data-id="element-9178" data-mp="3q8foyxc8in3l">
            {stats.map((stat, index) => <div key={index} className="rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all hover:translate-y-[-2px]" data-id="element-9179" data-mp="2tn5le7mgizhz" data-mpi={index}>
                <div className={`bg-gradient-to-r ${stat.color} p-5`} data-id="element-9180" data-mp="2q7uaqnzd69lg">
                  <div className="flex justify-between items-center" data-id="element-9181" data-mp="2q4yb8v7vbcuw">
                    <div data-id="element-9182" data-mp="2l8r3qxztptau">
                      <h3 className="text-sm font-medium text-white/80" data-id="element-9183" data-mp="2l6equz8xa94n">
                        {stat.title}
                      </h3>
                      <p className="text-3xl font-bold text-white mt-1" data-id="element-9184" data-mp="2c8ci1xiy6c6t">
                        {stat.value}
                      </p>
                    </div>
                    <div className="bg-white/20 p-2.5 rounded-xl" data-id="element-9185" data-mp="27ab0jh166kxg">
                      {stat.icon}
                    </div>
                  </div>
                  <div className="flex items-center text-sm text-white/80 mt-3" data-id="element-9186" data-mp="1xjonnuku88ig">
                    <TrendingUpIcon size={14} className="mr-1" data-id="element-9187" data-mp="1thl92x2vgnsy" />
                    <span className="font-medium text-white" data-id="element-9188" data-mp="1tf8m25i9bn91">
                      {stat.change}
                    </span>
                    <span className="ml-1" data-id="element-9189" data-mp="1jic99nlbseyo">this week</span>
                  </div>
                </div>
              </div>)}
          </div>

          {/* Quick Pivot Design Section */}
          <div className="mt-16 bg-gradient-to-br from-white/5 to-white/10 backdrop-blur-lg border border-white/10 rounded-3xl p-8 md:p-12 shadow-2xl relative overflow-hidden" data-id="element-9190" data-mp="3px8hqbli7nr4">
            {/* Background decorations */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-blue-500/10 rounded-full filter blur-3xl -z-10 translate-x-1/2 -translate-y-1/2" data-id="element-9191" data-mp="2jo4ngx8bjya"></div>
            <div className="absolute bottom-0 left-0 w-64 h-64 bg-teal-500/10 rounded-full filter blur-3xl -z-10 -translate-x-1/2 translate-y-1/2" data-id="element-9192" data-mp="3b09cuvi1e90c"></div>

            <div className="flex flex-col lg:flex-row gap-12 items-center" data-id="element-9193" data-mp="3kyfgbhjhrn7b">
              {/* Left: Text */}
              <div className="flex-1 text-left" data-id="element-9194" data-mp="3fy155qmlfx52">
                <div className="inline-flex items-center px-3 py-1 rounded-full bg-blue-500/20 text-blue-300 text-sm font-medium mb-6 border border-blue-500/30" data-id="element-9195" data-mp="3g1f8b1330adk">
                  <ZapIcon size={14} className="mr-2" data-id="element-9196" data-mp="v824813yuoby" />
                  Lightning Fast Design
                </div>
                <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 leading-tight" data-id="element-9197" data-mp="2d55fcp4uanws">
                  Design your next pivot in{' '}
                  <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-teal-400" data-id="element-9198" data-mp="246blv7mt2dng">
                    seconds
                  </span>
                </h2>
                <div className="space-y-5 text-blue-100/80 text-lg" data-id="element-9199" data-mp="2wufrxu9agsqo">
                  <p className="flex items-start" data-id="element-9200" data-mp="2wv92757gi0dk">
                    <CheckCircleIcon className="w-6 h-6 text-teal-400 mr-3 flex-shrink-0 mt-0.5" data-id="element-9201" data-mp="30wau10z1na5i" />
                    <span data-id="element-9202" data-mp="2n5ftqd2m21dj">
                      Designing a pivot in Aisco Workspace is incredibly easy
                      and intuitive.
                    </span>
                  </p>
                  <p className="flex items-start" data-id="element-9203" data-mp="3fss4zr3bmmrj">
                    <CheckCircleIcon className="w-6 h-6 text-teal-400 mr-3 flex-shrink-0 mt-0.5" data-id="element-9204" data-mp="3fs0lvfqwuhi5" />
                    <span data-id="element-9205" data-mp="3klcx8o6kwrsy">
                      Seamlessly choose between our flagship models, including
                      the CP600 and 8120.
                    </span>
                  </p>
                  <p className="flex items-start" data-id="element-9206" data-mp="3phpb0uha55rm">
                    <CheckCircleIcon className="w-6 h-6 text-teal-400 mr-3 flex-shrink-0 mt-0.5" data-id="element-9207" data-mp="3khbcc31kj869" />
                    <span data-id="element-9208" data-mp="3fj9kotq2u0j6">
                      Configure the tallest pivot on the market with just a few
                      clicks.
                    </span>
                  </p>
                </div>
              </div>

              {/* Right: Form */}
              <div className="w-full lg:w-[450px] bg-[#0f1d3a]/80 backdrop-blur-xl border border-white/10 rounded-2xl p-6 shadow-xl relative z-10" data-id="element-9209" data-mp="36od2xcsajfjp">
                <h3 className="text-xl font-semibold text-white mb-6 flex items-center" data-id="element-9210" data-mp="2wt1luntetw8s">
                  <PencilRulerIcon className="w-5 h-5 mr-2 text-blue-400" data-id="element-9211" data-mp="2rtoy80upsl55" />
                  Configure Pivot
                </h3>

                <div className="space-y-4" data-id="element-9212" data-mp="2nsve7ike7qhj">
                  {/* Name */}
                  <div data-id="element-9213" data-mp="13aaz7lr68z28">
                    <label className="block text-sm font-medium text-blue-300 mb-1.5" data-id="element-9214" data-mp="138zy5tp425et">
                      Name
                    </label>
                    <input type="text" defaultValue="New Pivot" className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-2.5 text-white placeholder-blue-300/50 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all" data-id="element-9215" data-mp="1ca7u4545mu5q" />
                  </div>

                  {/* Length & Area row */}
                  <div className="grid grid-cols-2 gap-4" data-id="element-9216" data-mp="okdi1prnt9mj">
                    <div data-id="element-9217" data-mp="okwtqoqpv1s4">
                      <label className="block text-sm font-medium text-blue-300 mb-1.5" data-id="element-9218" data-mp="tjq6gey6ior8">
                        Length
                      </label>
                      <div className="relative" data-id="element-9219" data-mp="yb86n0sdolb5">
                        <input type="number" defaultValue="50.01" step="0.01" className="w-full bg-white/5 border border-white/10 rounded-xl pl-4 pr-10 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all" data-id="element-9220" data-mp="v2i2ai4vj9g" />
                        <div className="absolute inset-y-0 right-0 flex items-center pr-4 pointer-events-none text-blue-300/50 text-sm" data-id="element-9221" data-mp="27kcpgeufqtu4">
                          m
                        </div>
                      </div>
                    </div>
                    <div data-id="element-9222" data-mp="2haz52925jkct">
                      <label className="block text-sm font-medium text-blue-300 mb-1.5" data-id="element-9223" data-mp="2chw4vi2vdcnn">
                        Area
                      </label>
                      <div className="relative" data-id="element-9224" data-mp="2r5h9jgfe7jxo">
                        <input type="number" defaultValue="0.786" step="0.001" className="w-full bg-white/5 border border-white/10 rounded-xl pl-4 pr-10 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all" data-id="element-9225" data-mp="2m8qv0xj8kwed" />
                        <div className="absolute inset-y-0 right-0 flex items-center pr-4 pointer-events-none text-blue-300/50 text-sm" data-id="element-9226" data-mp="2v9f7hnszeop5">
                          ha
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Degrees & Model row */}
                  <div className="grid grid-cols-2 gap-4" data-id="element-9227" data-mp="3ckaz3xc8tmqg">
                    <div data-id="element-9228" data-mp="3hg9jzayd4mm4">
                      <label className="block text-sm font-medium text-blue-300 mb-1.5" data-id="element-9229" data-mp="3hgj9yyjeqtrt">
                        Degrees
                      </label>
                      <div className="relative" data-id="element-9230" data-mp="37qzorm882nts">
                        <input type="number" defaultValue="360.00" step="0.01" className="w-full bg-white/5 border border-white/10 rounded-xl pl-4 pr-10 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all" data-id="element-9231" data-mp="37pokzmes1g2o" />
                        <div className="absolute inset-y-0 right-0 flex items-center pr-4 pointer-events-none text-blue-300/50 text-sm" data-id="element-9232" data-mp="2krk1pjitprzm">
                          °
                        </div>
                      </div>
                    </div>
                    <div data-id="element-9233" data-mp="j071h7rsw89w">
                      <label className="block text-sm font-medium text-blue-300 mb-1.5" data-id="element-9234" data-mp="ixulh05ls7zh">
                        Model
                      </label>
                      <div className="relative" data-id="element-9235" data-mp="1vza5324iv2bn">
                        <select className="w-full appearance-none bg-white/5 border border-white/10 rounded-xl pl-4 pr-10 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all" data-id="element-9236" data-mp="1vvusq728g7dx">
                          <option value="CP600" className="bg-slate-800" data-id="element-9237" data-mp="1hyfzer8uzfgo">
                            CP600
                          </option>
                          <option value="8120" className="bg-slate-800" data-id="element-9238" data-mp="2enf6i2xpib7a">
                            8120
                          </option>
                        </select>
                        <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none text-blue-300/50" data-id="element-9239" data-mp="25vvavpod8hgj">
                          <ChevronDownIcon size={16} data-id="element-9240" data-mp="20wirxg0m7uj8" />
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Submit Button */}
                  <div className="pt-4 mt-2 border-t border-white/10" data-id="element-9241" data-mp="2tl7msxb2v3mj">
                    <button onClick={() => onNavigate('design')} className="w-full flex items-center justify-center bg-blue-600 hover:bg-blue-500 text-white px-6 py-3 rounded-xl font-medium transition-all shadow-lg shadow-blue-900/20" data-id="element-9242" data-mp="30xxc4o4metig">
                      <CheckCircleIcon size={18} className="mr-2" data-id="element-9243" data-mp="3atqp28m94p0r" />
                      Create Pivot
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Aisco Library & School Section */}
          <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-9244" data-mp="3ou1fxbnka3lx">
            {/* Aisco Library Card */}
            <div className="group relative bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-lg border border-white/10 rounded-2xl shadow-xl overflow-hidden hover:border-blue-500/30 transition-all" data-id="element-9245" data-mp="3tn4clsnmxt6c">
              <div className="absolute top-0 right-0 w-48 h-48 bg-blue-500/5 rounded-full filter blur-3xl -z-10 translate-x-1/3 -translate-y-1/3" data-id="element-9246" data-mp="6iogdazrlnxj"></div>
              <div className="flex items-stretch" data-id="element-9247" data-mp="wqlrdk6g4b8t">
                {/* Left: Icon */}
                <div className="flex items-center justify-center px-6 py-8 flex-shrink-0" data-id="element-9248" data-mp="rs20r6gwqba4">
                  <img src="https://cdn.magicpatterns.com/uploads/tZ7NrQh25dhLzDu9ipDBZN/Icon-Aisco-Library.svg" alt="" className="h-24 w-auto filter brightness-0 invert opacity-20" data-id="element-9249" data-mp="16paychwt0baa" />
                </div>
                {/* Right: Content */}
                <div className="flex-1 py-6 pr-8" data-id="element-9250" data-mp="e1ovjbvehaoh">
                  <img src="https://cdn.magicpatterns.com/uploads/24jGJCEKwMDt9UpeMLAWch/Logo_Aisco_Library.svg" alt="Aisco Library" className="h-12 w-auto filter brightness-0 invert opacity-80 mb-4" data-id="element-9251" data-mp="dyawaci19hl9" />
                  <p className="text-blue-100/70 text-sm leading-relaxed mb-5" data-id="element-9252" data-mp="izqdtul055yw">
                    Explore the central hub for all our{' '}
                    <span className="text-white font-semibold" data-id="element-9253" data-mp="3rei8d9ws4ajg">
                      corporate documents
                    </span>
                    . Here you'll find the latest flyers, catalogs, manuals, and
                    technical documents, available for download in multiple
                    languages.
                  </p>
                  <a href="#" className="inline-flex items-center px-5 py-2.5 rounded-xl border border-white/20 text-white text-sm font-medium hover:bg-white/10 transition-all group-hover:border-blue-400/40" data-id="element-9254" data-mp="26r7lt6lw2oqx">
                    Visit Aisco Library
                    <ArrowRightIcon size={16} className="ml-2" data-id="element-9255" data-mp="2komf4mf9jgo6" />
                  </a>
                </div>
              </div>
            </div>

            {/* Aisco School Card */}
            <div className="group relative bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-lg border border-white/10 rounded-2xl shadow-xl overflow-hidden hover:border-teal-500/30 transition-all" data-id="element-9256" data-mp="2bor189ubp7kg">
              <div className="absolute top-0 right-0 w-48 h-48 bg-teal-500/5 rounded-full filter blur-3xl -z-10 translate-x-1/3 -translate-y-1/3" data-id="element-9257" data-mp="108szkr1h5nt9"></div>
              <div className="flex items-stretch" data-id="element-9258" data-mp="148jk4d0er7pc">
                {/* Left: Icon */}
                <div className="flex items-center justify-center px-6 py-8 flex-shrink-0" data-id="element-9259" data-mp="6kp9w4djpyg2">
                  <img src="https://cdn.magicpatterns.com/uploads/1Uu3MXehpc8ubSxFEbfghA/Icon-Aisco-School.svg" alt="" className="h-24 w-auto filter brightness-0 invert opacity-20" data-id="element-9260" data-mp="akzgnj95wsvz" />
                </div>
                {/* Right: Content */}
                <div className="flex-1 py-6 pr-8" data-id="element-9261" data-mp="3j1cbz5xukcmu">
                  <img src="https://cdn.magicpatterns.com/uploads/urNs8uWHp9W9chpxJat8Vo/Logo_Aisco_School.svg" alt="Aisco School" className="h-12 w-auto filter brightness-0 invert opacity-80 mb-4" data-id="element-9262" data-mp="3izrkjp6tx9t7" />
                  <p className="text-blue-100/70 text-sm leading-relaxed mb-5" data-id="element-9263" data-mp="3a27gk8hl0zew">
                    Access your gateway to technical knowledge on our products.
                    Here you'll find{' '}
                    <span className="text-white font-semibold" data-id="element-9264" data-mp="30303znio98su">
                      expert-led courses
                    </span>
                    . Learn at your own pace, enhance your skills, and download
                    materials upon completion.
                  </p>
                  <a href="#" className="inline-flex items-center px-5 py-2.5 rounded-xl border border-white/20 text-white text-sm font-medium hover:bg-white/10 transition-all group-hover:border-teal-400/40" data-id="element-9265" data-mp="2hf7rd6xrbdox">
                    Visit Aisco School
                    <ArrowRightIcon size={16} className="ml-2" data-id="element-9266" data-mp="2qh78s0coojse" />
                  </a>
                </div>
              </div>
            </div>
            {/* Alerts and pending orders section */}
            <div className="px-6 md:px-12 py-12 max-w-7xl mx-auto" data-id="element-9267" data-mp="30b7kwm6dupam">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-9268" data-mp="3e3xat1p18ed0">
                {/* Alerts section */}
                <div className="rounded-2xl overflow-hidden shadow-xl bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-lg border border-white/10" data-id="element-9269" data-mp="39642o3465aa3">
                  <div className="p-5 border-b border-white/10 flex justify-between items-center" data-id="element-9270" data-mp="3j4b7jnl6o1vq">
                    <h2 className="text-xl font-bold text-white flex items-center" data-id="element-9271" data-mp="3q7hrigrzqq67">
                      <div className="w-10 h-10 rounded-xl bg-gradient-to-r from-amber-500 to-orange-600 flex items-center justify-center mr-3 shadow-lg" data-id="element-9272" data-mp="3v59t62iftqnl">
                        <BellIcon size={20} className="text-white" data-id="element-9273" data-mp="3y72dc6ihmdw" />
                      </div>
                      Recent Alerts
                    </h2>
                    <div className="flex items-center space-x-2" data-id="element-9274" data-mp="dq2zajwv36gj">
                      <div className="px-2.5 py-1 bg-amber-500/20 text-amber-300 text-xs font-medium rounded-full flex items-center" data-id="element-9275" data-mp="hqwpjjxs0xcl">
                        <AlertCircleIcon size={12} className="mr-1" data-id="element-9276" data-mp="mpq0p5plcc9l" />4 quotes
                        expiring soon
                      </div>
                      <div className="px-2.5 py-1 bg-blue-500/20 text-blue-300 text-xs font-medium rounded-full flex items-center" data-id="element-9277" data-mp="rn011geiq8c7">
                        <FileTextIcon size={12} className="mr-1" data-id="element-9278" data-mp="2tg7cufuxa7tc" />3 new quotes
                      </div>
                      <button className="text-blue-300 hover:text-white transition-colors text-sm flex items-center bg-white/10 hover:bg-white/20 px-3 py-1.5 rounded-lg" data-id="element-9279" data-mp="2lxgb0fej49ri">
                        View all
                        <ChevronRightIcon size={16} className="ml-1" data-id="element-9280" data-mp="2c6lk2xqc8lzq" />
                      </button>
                    </div>
                  </div>
                  <div data-id="element-9281" data-mp="279v56dq9rwfw">
                    {alerts.map(alert => <div key={alert.id} className="p-4 hover:bg-white/5 transition-colors border-b border-white/10 last:border-0" data-id="element-9282" data-mp="34wc39l6tue2p">
                        <div className="flex items-start" data-id="element-9283" data-mp="2zx8xtzmxq5u7">
                          <div className={`mt-1 p-2 rounded-xl ${alert.priority === 'high' ? 'bg-gradient-to-br from-red-500/20 to-rose-500/20' : alert.priority === 'medium' ? 'bg-gradient-to-br from-amber-500/20 to-orange-500/20' : 'bg-gradient-to-br from-blue-500/20 to-indigo-500/20'}`} data-id="element-9284" data-mp="2ux3ct2b67hl3">
                            {alert.type === 'order' ? <FileTextIcon size={18} className={alert.priority === 'high' ? 'text-red-400' : alert.priority === 'medium' ? 'text-amber-400' : 'text-blue-400'} data-id="element-9285" data-mp="1eibk0oa448b9" /> : alert.type === 'quote' ? <DollarSignIcon size={18} className={alert.priority === 'high' ? 'text-red-400' : alert.priority === 'medium' ? 'text-amber-400' : 'text-blue-400'} data-id="element-9286" data-mp="3840nufccn5z9" /> : <PencilRulerIcon size={18} className={alert.priority === 'high' ? 'text-red-400' : alert.priority === 'medium' ? 'text-amber-400' : 'text-blue-400'} data-id="element-9287" data-mp="2th7fxv55t2h3" />}
                          </div>
                          <div className="ml-4 flex-1" data-id="element-9288" data-mp="3m1yx56btcc7w">
                            <h3 className="text-white font-medium" data-id="element-9289" data-mp="3r23gd443vl1t">
                              {alert.title}
                            </h3>
                            <p className="text-blue-200 text-sm mt-1" data-id="element-9290" data-mp="3c7yk8iaai2om">
                              {alert.description}
                            </p>
                            <div className="flex items-center mt-2 text-xs text-blue-300" data-id="element-9291" data-mp="20pnqvulvsu76">
                              <ClockIcon size={12} className="mr-1" data-id="element-9292" data-mp="25q20hh34sc7b" />
                              {alert.time} ago
                            </div>
                          </div>
                          <button className="text-blue-400 hover:text-white p-2 rounded-lg transition-colors hover:bg-white/10" data-id="element-9293" data-mp="itc888jb6c8e">
                            <ArrowRightIcon size={16} data-id="element-9294" data-mp="wrtue1tkfgo7" />
                          </button>
                        </div>
                      </div>)}
                  </div>
                  <div className="p-4 bg-gradient-to-r from-white/5 to-white/10" data-id="element-9295" data-mp="51fj8dcxsig8">
                    <button className="w-full flex items-center justify-center bg-gradient-to-r from-blue-600/50 to-indigo-600/50 hover:from-blue-600/70 hover:to-indigo-600/70 text-white py-2.5 rounded-xl transition-all" data-id="element-9296" data-mp="2ksmp8q9plk">
                      <RefreshCwIcon size={16} className="mr-2" data-id="element-9297" data-mp="92r0nvlnpxdc" />
                      Refresh alerts
                    </button>
                  </div>
                </div>
                {/* Pending orders section */}
                <div className="rounded-2xl overflow-hidden shadow-xl bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-lg border border-white/10" data-id="element-9298" data-mp="3dgfujvnyjch9">
                  <div className="p-5 border-b border-white/10 flex justify-between items-center" data-id="element-9299" data-mp="1lfxwild62p6j">
                    <h2 className="text-xl font-bold text-white flex items-center" data-id="element-9300" data-mp="1q6o1hxhokq0p">
                      <div className="w-10 h-10 rounded-xl bg-gradient-to-r from-teal-500 to-emerald-600 flex items-center justify-center mr-3 shadow-lg" data-id="element-9301" data-mp="1q90hi53voqb4">
                        <ClockIcon size={20} className="text-white" data-id="element-9302" data-mp="xj1x4n0mphcs" />
                      </div>
                      Pending Orders
                    </h2>
                    <button className="text-blue-300 hover:text-white transition-colors text-sm flex items-center bg-white/10 hover:bg-white/20 px-3 py-1.5 rounded-lg" data-id="element-9303" data-mp="17g6du7bpgkm7">
                      View all
                      <ChevronRightIcon size={16} className="ml-1" data-id="element-9304" data-mp="2ivbqo45jvzjj" />
                    </button>
                  </div>
                  <div className="p-4" data-id="element-9305" data-mp="2ntn38mn8co5g">
                    <div className="relative" data-id="element-9306" data-mp="2nslfpip1296u">
                      <input type="text" placeholder="Search orders..." className="w-full bg-white/5 border border-white/10 rounded-xl px-10 py-2.5 text-white placeholder-blue-300 focus:outline-none focus:ring-2 focus:ring-blue-500/50" data-id="element-9307" data-mp="c7kw1gfp4hvw" />
                      <SearchIcon className="absolute left-3.5 top-3 text-blue-300" size={16} data-id="element-9308" data-mp="2foxk49p6pr5" />
                    </div>
                  </div>
                  <div className="px-4" data-id="element-9309" data-mp="3oohtym7q3xga">
                    {pendingOrders.map((order, index) => <div key={order.id} className={`p-4 rounded-xl mb-3 ${order.status === 'pending' ? 'bg-gradient-to-r from-amber-500/10 to-orange-500/10 border border-amber-500/20' : order.status === 'review' ? 'bg-gradient-to-r from-blue-500/10 to-indigo-500/10 border border-blue-500/20' : 'bg-gradient-to-r from-emerald-500/10 to-teal-500/10 border border-emerald-500/20'}`} data-id="element-9310" data-mp="3omdfxbg41i2a" data-mpi={index}>
                        <div className="flex justify-between items-start" data-id="element-9311" data-mp="1dvncupvgy80t">
                          <div data-id="element-9312" data-mp="18ydbcbut25wm">
                            <div className="flex items-center" data-id="element-9313" data-mp="18v91oyykmhyk">
                              <span className="text-white font-medium" data-id="element-9314" data-mp="ht1341i6yqwe">
                                {order.customer}
                              </span>
                              <span className="ml-2 px-2 py-0.5 bg-white/10 rounded-full text-xs text-blue-200" data-id="element-9315" data-mp="826ckkxwx555">
                                {order.id}
                              </span>
                            </div>
                            <p className="text-blue-200 text-sm mt-1" data-id="element-9316" data-mp="3v6mijubl4or5">
                              {order.product}
                            </p>
                            <div className="mt-2 flex items-center" data-id="element-9317" data-mp="3yi665l0oflh">
                              <span className="text-lg font-bold text-white" data-id="element-9318" data-mp="3l9zyh7r321q6">
                                {order.amount}
                              </span>
                              <span className="ml-3 text-xs text-blue-300 flex items-center" data-id="element-9319" data-mp="1jhlbvvdlg93f">
                                <CalendarIcon size={12} className="mr-1" data-id="element-9320" data-mp="1og68lktn0an4" />
                                {order.date}
                              </span>
                            </div>
                          </div>
                          <div data-id="element-9321" data-mp="3405jv88ee098">
                            <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${order.status === 'pending' ? 'bg-gradient-to-r from-amber-500/20 to-orange-500/20 text-amber-300' : order.status === 'review' ? 'bg-gradient-to-r from-blue-500/20 to-indigo-500/20 text-blue-300' : 'bg-gradient-to-r from-emerald-500/20 to-teal-500/20 text-emerald-300'}`} data-id="element-9322" data-mp="340yqm97cwprd">
                              {order.status === 'pending' ? <>
                                  <AlertCircleIcon size={12} className="mr-1" data-id="element-9323" data-mp="5ia0k6dwlvwx" />
                                  Pending
                                </> : order.status === 'review' ? <>
                                  <FileTextIcon size={12} className="mr-1" data-id="element-9324" data-mp="278vb1ny0gc4a" />
                                  In review
                                </> : <>
                                  <CheckCircleIcon size={12} className="mr-1" data-id="element-9325" data-mp="22c4tew6k58gr" />
                                  Approved
                                </>}
                            </span>
                          </div>
                        </div>
                        <div className="mt-3 flex justify-end" data-id="element-9326" data-mp="12f41w6xsdupe">
                          <button className="text-blue-300 hover:text-white transition-colors text-sm bg-white/10 hover:bg-white/20 px-3 py-1.5 rounded-lg flex items-center" data-id="element-9327" data-mp="12dkn6krs3rpq">
                            View details
                            <ArrowRightIcon size={14} className="ml-1" data-id="element-9328" data-mp="niwhb5igur9l" />
                          </button>
                        </div>
                      </div>)}
                  </div>
                </div>
              </div>
              {/* Quote Score Overview */}
              <div className="mt-12" data-id="element-9329" data-mp="ek1e82apxxai">
                <div className="flex justify-between items-center mb-6" data-id="element-9330" data-mp="2dvlyc71dvxc1">
                  <h2 className="text-xl font-bold text-white flex items-center" data-id="element-9331" data-mp="28vzma0xakn4t">
                    <div className="w-10 h-10 rounded-xl bg-gradient-to-r from-blue-500 to-indigo-600 flex items-center justify-center mr-3 shadow-lg" data-id="element-9332" data-mp="28twkkjms15k9">
                      <StarIcon size={20} className="text-white" data-id="element-9333" data-mp="2ldto37et617r" />
                    </div>
                    Quote Score Overview
                  </h2>
                  <button className="text-blue-300 hover:text-white transition-colors text-sm flex items-center bg-white/10 hover:bg-white/20 px-3 py-1.5 rounded-lg" onClick={() => onNavigate('quotes')} data-id="element-9334" data-mp="2q7o2bvbn9nzg">
                    View all quotes
                    <ChevronRightIcon size={16} className="ml-1" data-id="element-9335" data-mp="22extvw2y9mtx" />
                  </button>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-9336" data-mp="27e0yjff0pr1d">
                  <div className="rounded-xl overflow-hidden shadow-lg bg-gradient-to-br from-green-500/20 to-emerald-500/20 backdrop-blur-lg border border-green-500/30 p-5" data-id="element-9337" data-mp="2bgxboqlsguxx">
                    <div className="flex justify-between items-start" data-id="element-9338" data-mp="3mvkl96uk0vdu">
                      <div data-id="element-9339" data-mp="3mtrelrjxyb5u">
                        <h3 className="text-white text-lg font-medium" data-id="element-9340" data-mp="1nqsv8v0wvehl">
                          High Score
                        </h3>
                        <p className="text-green-300 text-sm mt-1" data-id="element-9341" data-mp="1iqofj77tunsf">
                          Almost ready to close
                        </p>
                      </div>
                      <div className="bg-green-500/30 p-2 rounded-lg" data-id="element-9342" data-mp="1rsnxq2ukvxwy">
                        <StarIcon size={20} className="text-green-300" data-id="element-9343" data-mp="1rql83jxc86sr" />
                      </div>
                    </div>
                    <div className="mt-4" data-id="element-9344" data-mp="101i4859d4ygn">
                      <div className="text-3xl font-bold text-white" data-id="element-9345" data-mp="102t782uzi26p">3</div>
                      <p className="text-green-300 text-sm mt-1" data-id="element-9346" data-mp="1dswpyjunndre">
                        quotes with score 80+
                      </p>
                    </div>
                  </div>
                  <div className="rounded-xl overflow-hidden shadow-lg bg-gradient-to-br from-amber-500/20 to-orange-500/20 backdrop-blur-lg border border-amber-500/30 p-5" data-id="element-9347" data-mp="lbtzeu1z3ho6">
                    <div className="flex justify-between items-start" data-id="element-9348" data-mp="2s0mak1rm4e0x">
                      <div data-id="element-9349" data-mp="2rzb8c6dtfebx">
                        <h3 className="text-white text-lg font-medium" data-id="element-9350" data-mp="2wrb2fi77fd0l">
                          Medium Score
                        </h3>
                        <p className="text-amber-300 text-sm mt-1" data-id="element-9351" data-mp="2j0z6173l6s3n">
                          Under evaluation
                        </p>
                      </div>
                      <div className="bg-amber-500/30 p-2 rounded-lg" data-id="element-9352" data-mp="3bov1y9lc0fzd">
                        <StarIcon size={20} className="text-amber-300" data-id="element-9353" data-mp="3bmh6w0qnj3rt" />
                      </div>
                    </div>
                    <div className="mt-4" data-id="element-9354" data-mp="31qnymtjytwfu">
                      <div className="text-3xl font-bold text-white" data-id="element-9355" data-mp="31pmbhqpodjhr">4</div>
                      <p className="text-amber-300 text-sm mt-1" data-id="element-9356" data-mp="36opihgp7tzsd">
                        quotes with score 50-79
                      </p>
                    </div>
                  </div>
                  <div className="rounded-xl overflow-hidden shadow-lg bg-gradient-to-br from-red-500/20 to-rose-500/20 backdrop-blur-lg border border-red-500/30 p-5" data-id="element-9357" data-mp="1vav4r6dvf4ft">
                    <div className="flex justify-between items-start" data-id="element-9358" data-mp="2altgvramcl9a">
                      <div data-id="element-9359" data-mp="25rp9x81csd87">
                        <h3 className="text-white text-lg font-medium" data-id="element-9360" data-mp="25rfeh4xjhdv4">
                          Low Score
                        </h3>
                        <p className="text-red-300 text-sm mt-1" data-id="element-9361" data-mp="1wtd8sc2v1x1i">
                          Weak or uncertain
                        </p>
                      </div>
                      <div className="bg-red-500/30 p-2 rounded-lg" data-id="element-9362" data-mp="2tgi532a5ih1r">
                        <StarIcon size={20} className="text-red-300" data-id="element-9363" data-mp="2pi0z4m2gvclx" />
                      </div>
                    </div>
                    <div className="mt-4" data-id="element-9364" data-mp="2kjzie7sijpdm">
                      <div className="text-3xl font-bold text-white" data-id="element-9365" data-mp="2fjv14fjs6qmc">1</div>
                      <p className="text-red-300 text-sm mt-1" data-id="element-9366" data-mp="192q0vqsy37ey">
                        quotes with score below 50
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/* Go to dashboard button */}
              <div className="mt-12 text-center" data-id="element-9367" data-mp="ty510xfcmdg6">
                <button onClick={() => onNavigate('dashboard')} className="inline-flex items-center justify-center bg-gradient-to-r from-indigo-600/80 to-purple-600/80 hover:from-indigo-600 hover:to-purple-600 text-white px-8 py-4 rounded-xl transition-all shadow-lg hover:shadow-xl hover:translate-y-[-2px]" data-id="element-9368" data-mp="z046qdyk9mga">
                  <LayoutDashboardIcon size={20} className="mr-2" data-id="element-9369" data-mp="1cpo4f5dabtiq" />
                  Go to Dashboard
                  <ArrowRightIcon size={18} className="ml-2" data-id="element-9370" data-mp="1ho97rdnu2tbe" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Footer rediseñado */}
      <footer className="mt-auto relative z-10 bg-gradient-to-br from-blue-950 to-indigo-950 border-t border-blue-700/20" data-id="element-9371" data-mp="1rmf6jmecfjc1">
        <div className="absolute inset-0 bg-grid-white/[0.02] bg-[size:20px_20px]" data-id="element-9372" data-mp="3ohuv4551skvb"></div>
        <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-blue-500/20 to-transparent" data-id="element-9373" data-mp="3tfms3dkjux6d"></div>

        <div className="relative max-w-7xl mx-auto pt-16 pb-12 px-6" data-id="element-9374" data-mp="3gfc167etksn7">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10" data-id="element-9375" data-mp="3gh59rs8ztmxu">
            {/* Logo y descripción */}
            <div className="lg:col-span-2" data-id="element-9376" data-mp="3va8irb8iqscy">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/j7rsd4nQRUtzsXBFyA8c5B/AISCO_WORKSPACE_MARCA_NEGATIVO.svg" alt="Aisco Workspace" className="h-10 w-auto filter brightness-0 invert mb-6" data-id="element-9377" data-mp="3qcgowbobcw64" />
              <p className="text-blue-200 max-w-md mb-6" data-id="element-9378" data-mp="380wk53kdb2l">
                AISCO Workspace is a comprehensive management platform for
                irrigation systems, providing cutting-edge solutions for design,
                quotation, and management of PIVOT systems.
              </p>
              <div className="flex space-x-4" data-id="element-9379" data-mp="qzemk4e8suke">
                <a href="#" className="text-blue-300 hover:text-white transition-colors p-2 bg-white/5 rounded-full" data-id="element-9380" data-mp="qw0hupi3w99s">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-9381" data-mp="15lbquwit7c11">
                    <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" data-id="element-9382" data-mp="wknk8mvqwdy6"></path>
                  </svg>
                </a>
                <a href="#" className="text-blue-300 hover:text-white transition-colors p-2 bg-white/5 rounded-full" data-id="element-9383" data-mp="11hx7bvvnwdiu">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-9384" data-mp="mshjoorfgo7d">
                    <path d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z" data-id="element-9385" data-mp="drt4hqqashsw"></path>
                  </svg>
                </a>
                <a href="#" className="text-blue-300 hover:text-white transition-colors p-2 bg-white/5 rounded-full" data-id="element-9386" data-mp="3y2lh1cxwzkl">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-9387" data-mp="ockhviytkxqe">
                    <rect x="2" y="2" width="20" height="20" rx="5" ry="5" data-id="element-9388" data-mp="fbw5stszl7g5"></rect>
                    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" data-id="element-9389" data-mp="fdz0vs8zxqrq"></path>
                    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" data-id="element-9390" data-mp="af5ndztplzrk"></line>
                  </svg>
                </a>
                <a href="#" className="text-blue-300 hover:text-white transition-colors p-2 bg-white/5 rounded-full" data-id="element-9391" data-mp="5ft0jf2u8soz">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-9392" data-mp="3rt9ot62be9gl">
                    <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" data-id="element-9393" data-mp="3isl9m816q324"></path>
                    <rect x="2" y="9" width="4" height="12" data-id="element-9394" data-mp="3dti7avclaaxu"></rect>
                    <circle cx="4" cy="4" r="2" data-id="element-9395" data-mp="1tbpu4r3k6dh9"></circle>
                  </svg>
                </a>
              </div>
            </div>

            {/* Enlaces rápidos */}
            <div data-id="element-9396" data-mp="1y8zgtyzkcb1e">
              <h3 className="text-white text-lg font-semibold mb-6" data-id="element-9397" data-mp="1ycnacy50cxg4">
                Quick Links
              </h3>
              <ul className="space-y-3" data-id="element-9398" data-mp="27b8pejb9tuc5">
                <li data-id="element-9399" data-mp="27a7eqfy639uy">
                  <a href="#" className="text-blue-300 hover:text-white transition-colors flex items-center" data-id="element-9400" data-mp="27apevnnya885">
                    <span className="w-1.5 h-1.5 bg-blue-400 rounded-full mr-2" data-id="element-9401" data-mp="1ajetz50agtmu"></span>
                    Dashboard
                  </a>
                </li>
                <li data-id="element-9402" data-mp="1jl4l09q9dqk3">
                  <a href="#" className="text-blue-300 hover:text-white transition-colors flex items-center" data-id="element-9403" data-mp="1jkmr3jr2jofc">
                    <span className="w-1.5 h-1.5 bg-blue-400 rounded-full mr-2" data-id="element-9404" data-mp="1oer1kczjmel6"></span>
                    Design System
                  </a>
                </li>
                <li data-id="element-9405" data-mp="vvacg4cz2o5n">
                  <a href="#" className="text-blue-300 hover:text-white transition-colors flex items-center" data-id="element-9406" data-mp="vuipfhxfxyqz">
                    <span className="w-1.5 h-1.5 bg-blue-400 rounded-full mr-2" data-id="element-9407" data-mp="37hko1xp9x2t5"></span>
                    Quotes
                  </a>
                </li>
                <li data-id="element-9408" data-mp="3gk3qwht27ffe">
                  <a href="#" className="text-blue-300 hover:text-white transition-colors flex items-center" data-id="element-9409" data-mp="3gislkdjytzm6">
                    <span className="w-1.5 h-1.5 bg-blue-400 rounded-full mr-2" data-id="element-9410" data-mp="3lcdbdibennaa"></span>
                    Orders
                  </a>
                </li>
                <li data-id="element-9411" data-mp="3v8gmves5cy9w">
                  <a href="#" className="text-blue-300 hover:text-white transition-colors flex items-center" data-id="element-9412" data-mp="3v7x3dtmum1tr">
                    <span className="w-1.5 h-1.5 bg-blue-400 rounded-full mr-2" data-id="element-9413" data-mp="35yw9g1eh7ab"></span>
                    Dealers
                  </a>
                </li>
              </ul>
            </div>

            {/* Legal y soporte */}
            <div data-id="element-9414" data-mp="24z6otr60xle5">
              <h3 className="text-white text-lg font-semibold mb-6" data-id="element-9415" data-mp="29vn92aa3rfly">
                Support & Legal
              </h3>
              <ul className="space-y-3" data-id="element-9416" data-mp="22cnr892ahw4p">
                <li data-id="element-9417" data-mp="22dp7cry5x8ta">
                  <a href="#" className="text-blue-300 hover:text-white transition-colors flex items-center" data-id="element-9418" data-mp="1xlnwnagn7q5d">
                    <span className="w-1.5 h-1.5 bg-blue-400 rounded-full mr-2" data-id="element-9419" data-mp="1smba6qtool3b"></span>
                    Help Center
                  </a>
                </li>
                <li data-id="element-9420" data-mp="1npb2kbh6raa3">
                  <a href="#" className="text-blue-300 hover:text-white transition-colors flex items-center" data-id="element-9421" data-mp="1nln9fdfnkpvw">
                    <span className="w-1.5 h-1.5 bg-blue-400 rounded-full mr-2" data-id="element-9422" data-mp="2gc5jiyesnrit"></span>
                    Contact Us
                  </a>
                </li>
                <li data-id="element-9423" data-mp="2bbhnfybpkkhq">
                  <a href="#" className="text-blue-300 hover:text-white transition-colors flex items-center" data-id="element-9424" data-mp="2bex1cxtnbnhk">
                    <span className="w-1.5 h-1.5 bg-blue-400 rounded-full mr-2" data-id="element-9425" data-mp="zxxcydaf5sst"></span>
                    Terms of Service
                  </a>
                </li>
                <li data-id="element-9426" data-mp="vv0nc2mgowfd">
                  <a href="#" className="text-blue-300 hover:text-white transition-colors flex items-center" data-id="element-9427" data-mp="vyoit7bgvswq">
                    <span className="w-1.5 h-1.5 bg-blue-400 rounded-full mr-2" data-id="element-9428" data-mp="12ck8uv865uty"></span>
                    Privacy Policy
                  </a>
                </li>
                <li data-id="element-9429" data-mp="nes0cn11i6p9">
                  <a href="#" className="text-blue-300 hover:text-white transition-colors flex items-center" data-id="element-9430" data-mp="nhnue09rob8f">
                    <span className="w-1.5 h-1.5 bg-blue-400 rounded-full mr-2" data-id="element-9431" data-mp="emzs8izhn9nu"></span>
                    Cookie Policy
                  </a>
                </li>
              </ul>
            </div>
          </div>
          {/* Botones de contacto */}
          <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-6" data-id="element-9432" data-mp="4q4rdtfqsx6e">
            <div className="flex flex-wrap gap-3" data-id="element-9433" data-mp="9lsfe5ihnkab">
              <button className="bg-white/5 hover:bg-white/10 text-blue-200 px-4 py-2 rounded-lg transition-colors flex items-center border border-white/10" data-id="element-9434" data-mp="3rukoedbft6g9">
                <HeadphonesIcon size={16} className="mr-2" data-id="element-9435" data-mp="3d6t0ca7c52x4" />
                Support
              </button>
              <button className="bg-white/5 hover:bg-white/10 text-blue-200 px-4 py-2 rounded-lg transition-colors flex items-center border border-white/10" data-id="element-9436" data-mp="387pxmwetv8sb">
                <MailIcon size={16} className="mr-2" data-id="element-9437" data-mp="3m926yozhgc58" />
                Contact
              </button>
              <button className="bg-white/5 hover:bg-white/10 text-blue-200 px-4 py-2 rounded-lg transition-colors flex items-center border border-white/10" data-id="element-9438" data-mp="3h7355jje5nae">
                <MessageSquareIcon size={16} className="mr-2" data-id="element-9439" data-mp="3r7djx8l2r2ro" />
                Feedback
              </button>
            </div>
            {/* Copyright */}
            <div className="text-blue-300 text-sm" data-id="element-9440" data-mp="8ufeim5ijhq4">
              © 2025 Aisco Workspace | Version: 2.2.0
            </div>
          </div>

          {/* Decoración */}
          <div className="absolute bottom-0 right-0 w-64 h-64 bg-blue-600/10 rounded-full filter blur-3xl -z-10" data-id="element-9441" data-mp="irabv1q1vc2t"></div>
          <div className="absolute top-12 left-12 w-48 h-48 bg-indigo-600/10 rounded-full filter blur-3xl -z-10" data-id="element-9442" data-mp="dpkyhffcumbk"></div>
        </div>
      </footer>
    </div>;
}